import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Typography,
  Tooltip,
  Box,
  TableSortLabel,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { SPARES_BY_MODEL_ID_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  SpareListingByModelIdService,
  FindSpareByArticleCodeService,
  LinkSpareWithModelService,
} from "../../services/ModelViewService";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import EditIcon from "@mui/icons-material/Edit";
import LinkSpareDialog from "./LinkSpareDialog";
import { useForm } from "react-hook-form";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import DownloadIcon from "@mui/icons-material/Download";
import download from "downloadjs";
import { visuallyHidden } from "@mui/utils";
import DetailsIcon from "@mui/icons-material/Details";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";
import { DownloadAltAndLinkedSpareService } from "../../services/DownloadAltAndLinkedSpareService";
import useGlobalState from "../../Context";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const ModelView = () => {
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sparesByModelId, setSparesByModelId] = useState([]);
  const [searchedRows, setSearchedRows] = useState(sparesByModelId);
  const [totalElements, setTotalElements] = useState(0);
  const [openAddModelDialog, setOpenAddModelDialog] = useState(false);
  const [formData, setFormData] = useState({});
  const [disableDownloadButton, setDisableDownloadButton] = useState(true);
  const [articleCode, setArticleCode] = useState(null);
  const { setLoading } = useLoading();
  const [sortValue, setSortValue] = useState(null);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("code");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [slcRow, setSlcRow] = React.useState(null);
  const [{ auth, spareAccessRights }, dispatch] = useGlobalState();
  const loginParam = auth.ldapParam;
  const { showNotification } = useNotificationContext();
  const navigate = useNavigate();
  const { id, brand, modelName } = useParams();
  const mID = id.replace(":id", id);
  const open = Boolean(anchorEl);
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSlcRow(row);
  };

  const formOption = {
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm(formOption);

  useEffect(() => {
    getSpareByModelId("code", true, parseInt(mID));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset(formData);
    setFormData({})
    setArticleCode(null)
  }, [openAddModelDialog]);

  const goBack = () => {
    navigate("/model-search");
  };
  const getSpareByModelId = async (sortBy, isAsc, id) => {
    try {
      const obj = {
        spareModelSearchParam: {
          modelId: id,
        },
        sparePage: {
          pageSize: 10,
          pageNumber: 0,
          sortDirection: isAsc ? "DESC" : "ASC",
          sortBy: sortBy,
        },
      };
      const res = await SpareListingByModelIdService(obj);
      if (res.statusCode === 6) {
        setSparesByModelId(res.data.content);
        setTotalElements(res.data.totalElements);
        if (res.data.content.length > 0) {
          setDisableDownloadButton(false);
        }
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
  const handlspareListItem = (e, itemAction) => {
    let row = slcRow;
    setAnchorEl(null);
    if (itemAction === "view") {
      navigate(`/spare-view/${row?.spareId}`, {
        state: { code: row?.code, spareDescription: row?.spareDescription },
      });
    } else if (itemAction === "edit") {
      navigate("/spare-search/Edit-spare", {
        state: { id: row?.spareId, isEdit: true },
      });
    } else if (itemAction === "detail") {
      navigate(`/spare-details/${row?.spareId}`);
    } else if (itemAction === "photo") {
      navigate(`/spare-photos/${row?.spareId}`, {
        state: { code: row?.code, description: row?.spareDescription },
      });
    } else if (itemAction === "modelInfo") {
      navigate(`/models-detail/${row?.spareId}`, {
        state: { code: row?.code, spareDescription: row?.spareDescription },
      });
    } else if (itemAction === "vendorInfo") {
      navigate(`/vendors-detail/${row?.spareId}`, {
        state: { type: "VENDORS" },
      });
    } else if (itemAction === "suppliersInfo") {
      navigate(`/suppliers-detail/${row?.spareId}`, {
        state: { type: "SUPPLIERS" },
      });
    } else {
      console("error in spare extra listing menu");
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const selectedRows =
      sparesByModelId &&
      sparesByModelId.filter(
        (row) => row && row.modelName && row.modelName.toUpperCase()
      );
    setSearchedRows(selectedRows);
  }, [sparesByModelId]);

  const handleClickOpenOnAdd = async () => {
    setOpenAddModelDialog(true);
  };

  const handleClose = () => {
    setOpenAddModelDialog(false);
    setFormData({});
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };

    await handleModeViewTableChanges(paginationValues, false);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleModeViewTableChanges(paginationValues, true);
    }
    setPage(newPage);
  };

  const handleModeViewTableChanges = async (paginationValues, isUpdate) => {
    try {
      setLoading(true);
      const obj = {
        spareModelSearchParam: {
          modelId: parseInt(mID),
        },
        sparePage: {
          pageNumber: paginationValues?.pageNumber ?? 0,
          pageSize: paginationValues?.pageSize ?? 10,
          sortDirection: "ASC",
          sortBy: "spareId",
        },
      };
      const response = await SpareListingByModelIdService(obj);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setSparesByModelId([...sparesByModelId, ...response.data.content]);
        } else {
          setSparesByModelId(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const getSpareByArticleCode = async () => {
    try {
      setLoading(true);
      const response = await FindSpareByArticleCodeService(articleCode);
      if (response.statusCode === 6) {
        reset(formData);
        setFormData({
          description: response.data.description,
          partName: response.data.partTypeName,
          spareId: response.data.spareId,
        });
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const onLinkSpareWithModelSubmit = async () => {
    try {
      setLoading(true);
      const requestBody = {
        modelId: parseInt(id),
        spareId: formData.spareId,
        createdOn: new Date(),
        createdBy: loginParam.userId,
        createdByName: loginParam.name,
      };
      const response = await LinkSpareWithModelService(requestBody);
      if (response.statusCode === 6) {
        showNotification("Success", response.message, "success");
        handleClose();
        getSpareByModelId("code", true, mID);
        setPage(0);
        setMaxPage(0);
      } else {
        showNotification("Error", response.message, "error");
        handleClose();
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    getSpareByModelId(property, isAsc, mID);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 8 }}>
        <Grid
          container
          spacing={1}
          sx={{ pl: 3, pr: 3, mt: 1, mb: 3 }}
          display="flex"
        >
          <Grid item xs={8}>
            <Typography
              align="left"
              sx={{
                mr: "auto",
                mt: 1 / 2,
                color: "#003f93",
                // fontWeight: "bold",
              }}
              variant="h6"
            >
              <IconButton sx={{ color: "#003f93" }}>
                <ArrowBackIcon onClick={goBack} />
              </IconButton>
              Model Details : {brand}/{modelName}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography align="right">
              {spareAccessRights.addDelete ? (
                <Tooltip title="Link Spare">
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleClickOpenOnAdd();
                    }}
                    sx={{ ml: 1 }}
                    className="button-primary-alt-contained"
                  >
                    Link Spare{" "}
                  </Button>
                </Tooltip>
              ) : null}
              {loginParam.rilUser ? (
                <Tooltip title="Download Linked Spare">
                  <Button
                    variant="contained"
                    className="button-primary-alt-contained"
                    startIcon={<DownloadIcon />}
                    sx={{ ml: 1 }}
                    disabled={disableDownloadButton}
                    onClick={async () => {
                      try {
                        setLoading(true);
                        const response = await DownloadAltAndLinkedSpareService(
                          1,
                          parseInt(mID)
                        );
                        const content = response.headers["content-type"];
                        download(response.data, "LinkedSpareList.csv", content);
                      } catch (err) {
                        showNotification("Error", "Failed To Fetch");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Download
                  </Button>
                </Tooltip>
              ) : null}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ mt: 2 }}>
            <Paper elevation={3} variant="elevation">
              <TableContainer sx={{ maxHeight: "720" }}>
                <Table aria-labelledby="tableTitle" size="small">
                  <TableHead>
                    <TableRow key={"1"}>
                      {SPARES_BY_MODEL_ID_LISTING_COLUMNS.map((headCell) => (
                        <TableCell
                          className="tableHeader"
                          size="small"
                          variant="head"
                          key={headCell.id}
                          sx={{ pt: 1.5, pb: 1.5 }}
                          style={{
                            minWidth: headCell.minWidth,
                            fontWeight: "bold",
                            color: "#003A6B",
                          }}
                          sortDirection={
                            orderBy === headCell.id ? order : false
                          }
                        >
                          <TableSortLabel
                            active={
                              headCell.id === "warranty" ||
                              headCell.id === "billingPr" ||
                              headCell.id === "retailPr" ||
                              headCell.id === "noOfElements"
                                ? false
                                : orderBy === headCell.id
                            }
                            direction={orderBy === headCell.id ? order : "asc"}
                            onClick={createSortHandler(headCell.id)}
                            hideSortIcon={
                              (headCell.id === "warranty" ||
                                headCell.id === "billingPr" ||
                                headCell.id === "retailPr" ||
                                headCell.id === "noOfElements") &&
                              true
                            }
                            disabled={
                              (headCell.id === "warranty" ||
                                headCell.id === "billingPr" ||
                                headCell.id === "retailPr" ||
                                headCell.id === "noOfElements") &&
                              true
                            }
                          >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          return (
                            <TableRow
                              tabIndex={-1}
                              hover
                              role="checkbox"
                              key={row.spareId}
                            >
                              <TableCell size="medium" key={"code"}>
                                {`${row["code"]}` ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"spareDescription"}
                                title={
                                  row?.spareDescription
                                    ? row.spareDescription
                                    : ""
                                }
                              >
                                {(row.spareDescription &&
                                  row.spareDescription?.slice(0, 25)) ||
                                  "-"}
                                {row.spareDescription &&
                                row.spareDescription.length > 25
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>
                              <TableCell size="medium" key={"partName"}>
                                {row["partName"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"warranty"}>
                                {row["warranty"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"billingPr"}>
                                {row["billingPr"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"retailPr"}>
                                {row["retailPr"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"defSpareActionName"}
                              >
                                {row["defSpareActionName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"hasAlternateSpare"}
                              >
                                {(row["hasAlternateSpare"] ? "Yes" : "No") ??
                                  "-"}
                              </TableCell>
                              <TableCell size="medium" key={"noOfElements"}>
                                {row["noOfElements"] ?? "-"}
                              </TableCell>
                              <TableCell>
                                <MoreVertIcon
                                  onClick={(event) => {
                                    handleClick(event, row);
                                  }}
                                  fontSize="small"
                                />
                                <Menu
                                  id="basic-menu"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleCloseMenu}
                                  MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                  }}
                                >
                                  <MenuItem
                                    onClick={(e) => {
                                      handlspareListItem(e, "view");
                                    }}
                                  >
                                    <VisibilityIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Alternate Spares
                                  </MenuItem>
                                  {spareAccessRights.write ? (
                                    <MenuItem
                                      onClick={(e) => {
                                        handlspareListItem(e, "edit");
                                      }}
                                    >
                                      <EditIcon
                                        fontSize="medium"
                                        color="disabled"
                                        sx={{ mr: 1 }}
                                      />
                                      Edit
                                    </MenuItem>
                                  ) : null}
                                  <MenuItem
                                    onClick={(e) => {
                                      handlspareListItem(e, "detail");
                                    }}
                                  >
                                    <DetailsIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Spare Details
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) =>
                                      handlspareListItem(e, "photo")
                                    }
                                  >
                                    <AddPhotoAlternateIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Spare Photo
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) => {
                                      handlspareListItem(e, "modelInfo");
                                    }}
                                  >
                                    <VisibilityIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Models Detail
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) => {
                                      handlspareListItem(e, "vendorInfo");
                                    }}
                                  >
                                    <VisibilityIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Vendors Detail
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) => {
                                      handlspareListItem(e, "suppliersInfo");
                                    }}
                                  >
                                    <VisibilityIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    Suppliers Detail
                                  </MenuItem>
                                </Menu>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <RecordNotFound />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <LinkSpareDialog
              openDialog={openAddModelDialog}
              handleClose={handleClose}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              formData={formData}
              getSpareByArticleCode={getSpareByArticleCode}
              setArticleCode={setArticleCode}
              onLinkSpareWithModelSubmit={onLinkSpareWithModelSubmit}
              setValue={setValue}
            />
          </Grid>
        </Grid>
        {/* </Paper> */}
      </Container>
    </>
  );
};

export default ModelView;
